import { render, staticRenderFns } from "./BackupOverview.vue?vue&type=template&id=f467698a&scoped=true&"
import script from "./BackupOverview.vue?vue&type=script&lang=js&"
export * from "./BackupOverview.vue?vue&type=script&lang=js&"
import style0 from "./BackupOverview.vue?vue&type=style&index=0&id=f467698a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f467698a",
  null
  
)

export default component.exports